export default () => {
    return useCookie<object>('pilulkaCookieSettings', {
        maxAge: 2592000, // 30 days
        secure: true,
    })
}
